const $ = jQuery.noConflict();

window.searchRecommendation = async function() {
  let params = new URLSearchParams({
    action: "ajaxsearch",
    searchterm: $("header input.search").val(),
  });
  let query = params.toString();
  return fetch(ajax_search_object.ajaxurl + "?" + query, {
    headers: {
      "Content-Type": "application/json",
    },
  }).then((resp) => resp.json());
}
